import { Button } from "@/components/ui/Button";
import { useSessionStore } from "@/store/SessionStore";
import { SquarePen } from "lucide-react";
import { useChatContext } from "@/components/chatview/ChatContext";
import { useChatIdStore } from "@/store/ChatIdStore";

interface NewChatProps {
  onClearMessages?: () => void;
  onClose?: () => void;
  onClearSelection?: (id: number | null) => void;
}

export function NewChat({
  onClearMessages,
  onClose,
  onClearSelection,
}: NewChatProps) {
  const clearsessionid = useSessionStore(
    (state) => state.clearslocalStorageSessionId
  );
  const { setActiveQuote } = useChatContext();
  const { setStartChatId } = useChatIdStore();

  const handleNewChat = () => {
    onClearMessages?.();
    clearsessionid();
    onClearSelection?.(null);
    setActiveQuote?.(null);
    setStartChatId(0);
    onClose?.();
  };

  return (
    <Button
      variant="ghost"
      className="gap-3 w-full justify-start hover:bg-accent hover:text-blue-600 group px-2 text-[#0F0F0F]"
      onClick={handleNewChat}
    >
      <div className="h-5.5 w-5.5 flex items-center justify-center">
        <SquarePen className="group-hover:text-blue-600" />
      </div>
      <span className="text-[#0F0F0F] text-base">新会话</span>
    </Button>
  );
}
